import { useBoolean } from '@chakra-ui/react';
import React, { createContext, useState } from 'react';
import { DownloadContextData } from './types';

export const DownloadContext = createContext<DownloadContextData>(
  {} as DownloadContextData,
);

export const DownloadProvider: React.FC = ({ children }) => {
  const [isActive, setIsActive] = useBoolean(false);
  const [docUUID, setDocUUID] = useState('');

  const clearL = () => {
    setIsActive.off();
    setDocUUID('');
  };

  const apply = (active: boolean, uuid: string) => {
    if (active) {
      setIsActive.on();
      setDocUUID(uuid);
    } else {
      clearL();
    }
  };

  return (
    <DownloadContext.Provider value={{ apply, isActive, docUUID }}>
      {children}
    </DownloadContext.Provider>
  );
};
